$(document).ready(function () {
    'use strict';

    $('.js_reveal').on('click', function (e) {
    	e.preventDefault();

        $('body').addClass('revealed');

        $.ajax({
            type: 'post',
            url: '/plugins/BigReveal/ajax/black_friday_session.php',
            success: function (response) {

            }
        });
    });

}); // document ready